import i18next from "i18next";

export const getAccountOmlat = (accOMS, omlat) => {
  var oml = omlat?.filter((om) => accOMS?.findIndex((am) => String(am) === String(om.id)) !== -1);

  return oml;
};

export const getDefaultOmla = (omlat) => {
  if (!omlat) alert(i18next.t("forms:no-currencies"));
  else {
    var oml = omlat?.filter((om) => om.IS_Default === true || om.IS_Default === 1 || om.IS_Default === "1");
    console.log("oml is", oml);
    if (!oml) return omlat[0];
    else return oml[0];
  }
};
